export const OPEN_ASSIGN_MODAL_BY_FPT_ID = "OPEN_ASSIGN_MODAL_BY_FPT_ID";
export const CLOSE_ASSIGN_MODAL = "CLOSE_ASSIGN_MODAL";
